export default "__VITE_ASSET__BbZny0vn__"